import React, { useState } from "react";
import PageTitle from '../../Component/Comman/PageTitle';
import { Tab, Nav } from "react-bootstrap";
import DataTable from 'react-data-table-component';

function Bill() {
    const [searchText, setSearchText] = useState('');

    // Data definition for DataTable
    const miningData = {
        columns: [
            { name: "MINING DATE", selector: row => row.date, sortable: true },
            { name: "COIN", selector: row => row.coin, sortable: true },
            { name: "MINING ACCOUNT", selector: row => row.account, sortable: true },
            { name: "TOTAL HASHRATE", selector: row => row.hashrate, sortable: true },
            { name: "SETTLEMENT EARNINGS (BTC)", selector: row => row.earnings, sortable: true },
            { name: "SETTLEMENT TIME", selector: row => row.time, sortable: true },
        ],
        rows: [
            { id: 1, date: '2025-12-24', coin: 'BTC', account: 'Main Account', hashrate: '110.4 TH/s', earnings: '0.00042', time: '2025-12-25 01:00' },
            { id: 2, date: '2025-12-23', coin: 'BTC', account: 'Main Account', hashrate: '108.9 TH/s', earnings: '0.00040', time: '2025-12-24 01:00' },
            { id: 3, date: '2025-12-22', coin: 'BTC', account: 'Main Account', hashrate: '111.6 TH/s', earnings: '0.00044', time: '2025-12-23 01:00' },
        ]
    };

    const rebateData = {
        columns: [
            { name: "DATE", selector: row => row.date, sortable: true },
            { name: "COIN", selector: row => row.coin, sortable: true },
            { name: "REBATE TYPE", selector: row => row.type, sortable: true },
            { name: "REBATE RATE", selector: row => row.rate, sortable: true },
            { name: "EARNINGS (BTC)", selector: row => row.earnings, sortable: true },
            { name: "SETTLEMENT TIME", selector: row => row.time, sortable: true },
        ],
        rows: [
            { id: 1, date: '2025-12-24', coin: 'BTC', type: 'Pool Rebate', rate: '2%', earnings: '0.00006', time: '2025-12-25 01:10' },
            { id: 2, date: '2025-12-23', coin: 'BTC', type: 'Pool Rebate', rate: '2%', earnings: '0.00005', time: '2025-12-24 01:10' },
        ]
    };

    const transferData = {
        columns: [
            { name: "DATE", selector: row => row.date, sortable: true },
            { name: "COIN", selector: row => row.coin, sortable: true },
            { name: "FROM ACCOUNT", selector: row => row.from, sortable: true },
            { name: "TO ACCOUNT", selector: row => row.to, sortable: true },
            { name: "AMOUNT (BTC)", selector: row => row.amount, sortable: true },
            { name: "STATUS", selector: row => row.status, sortable: true, cell: row => <span className="badge bg-success">{row.status}</span> },
        ],
        rows: [
            { id: 1, date: '2025-12-24', coin: 'BTC', from: 'Mining Wallet', to: 'Main Wallet', amount: '0.00015', status: 'Completed' },
            { id: 2, date: '2025-12-22', coin: 'BTC', from: 'Mining Wallet', to: 'Main Wallet', amount: '0.00017', status: 'Completed' },
        ]
    };

    // Filter function for search
    const filterData = (data) => {
        if (!searchText) return data;

        return data.filter(item => {
            return Object.values(item).some(val =>
                String(val).toLowerCase().includes(searchText.toLowerCase())
            );
        });
    };

    return (
        <>
            <div className="body-header border-bottom d-flex py-3 mb-3">
                <PageTitle pagetitle="Bill" downloadbutton="Download" reportbutton="Generate Report" />
            </div>
            <div className="container-xxl">
                {/* Top Tabs */}
                <ul className="nav nav-tabs tab-body-header rounded d-inline-flex mb-3">
                    <li className="nav-item">
                        <a className="nav-link" href="#">Hashrate</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link active" href="#">Main Account Bill</a>
                    </li>
                </ul>

                {/* Filters */}
                <div className="row g-3 align-items-end mb-4">
                    <div className="col-md-3">
                        <label className="form-label">Date</label>
                        <input type="date" className="form-control" />
                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Coin</label>
                        <select className="form-select">
                            <option>All</option>
                            <option>BTC</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Account</label>
                        <select className="form-select">
                            <option>All</option>
                            <option>Main Account</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-outline-secondary w-100">Reset</button>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-warning w-100">Search</button>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="row g-4 mb-4">
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <h6>Total Mining Earnings</h6>
                                <p>BTC: <strong>0.00126</strong></p>
                                <p>ETH: <strong>0.00000</strong></p>
                                <p>LTC: <strong>0.00036</strong></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <h6>Total Rebate Earnings</h6>
                                <p>BTC: <strong>0.00018</strong></p>
                                <p>ETH: <strong>0.00000</strong></p>
                                <p>LTC: <strong>0.00007</strong></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <h6>Total Transfer Earnings</h6>
                                <p>BTC: <strong>0.00032</strong></p>
                                <p>ETH: <strong>0.00000</strong></p>
                                <p>LTC: <strong>0.00012</strong></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        {/* Search Box */}
                        <div className="row mb-3">
                            <div className="col-sm-12 col-md-12">
                                <div id="myDataTable_filter" className="dataTables_filter">
                                    <label className='d-flex align-items-center justify-content-end'>
                                        Search:
                                        <div className='mx-1'>
                                            <input
                                                type="search"
                                                className="form-control"
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                placeholder="Search..."
                                            />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <Tab.Container defaultActiveKey="mining">
                            {/* Inner Tabs */}
                            <Nav variant="tabs" className="tab-body-header rounded mb-3 d-flex">
                                <Nav.Item>
                                    <Nav.Link eventKey="mining">Mining details</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="rebate">Rebate details</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="transfer">Transfer details</Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content>
                                {/* Mining Details */}
                                <Tab.Pane eventKey="mining">
                                    <DataTable
                                        columns={miningData.columns}
                                        data={filterData(miningData.rows)}
                                        defaultSortField="date"
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                    />
                                </Tab.Pane>

                                {/* Rebate Details */}
                                <Tab.Pane eventKey="rebate">
                                    <DataTable
                                        columns={rebateData.columns}
                                        data={filterData(rebateData.rows)}
                                        defaultSortField="date"
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                    />
                                </Tab.Pane>

                                {/* Transfer Details */}
                                <Tab.Pane eventKey="transfer">
                                    <DataTable
                                        columns={transferData.columns}
                                        data={filterData(transferData.rows)}
                                        defaultSortField="date"
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                    />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Bill;
